import request from '../../request';
import { SHARED_API_URL, FORM_HEADERS } from '../../../constants/shared/ApiConstants';

class MASClient {
    fetchMASToken = async token => {
        this.masToken = await request
            .post(`${SHARED_API_URL().BASE_URLS.MAS_TOKEN_URL}`, `kc_access_token=${token}`, {
                headers: FORM_HEADERS,
            })
            .then(data => data.auth_token);
    };

    getMasToken = () => this.masToken;
}

export default new MASClient();
